import { useLang } from "@/context/LangContext";
import { SERVICES } from "@/data/content";

export default function Marquee() {
    const { lang } = useLang();
    const items = SERVICES.map((s) => s.title[lang]);

    return (
        <div
            data-testid="marquee-band"
            className="overflow-hidden border-y border-ink/10 bg-cream py-5 text-ink md:py-6"
        >
            <div className="flex w-max animate-marquee">
                {[0, 1].map((dup) => (
                    <div key={dup} className="flex shrink-0 items-center" aria-hidden={dup === 1}>
                        {items.map((it, i) => (
                            <span
                                key={i}
                                className="flex items-center font-display text-lg font-bold uppercase tracking-tight md:text-2xl"
                            >
                                <span className="px-6 md:px-10">{it}</span>
                                <span className="text-violet">✦</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
